import React from 'react'
import { H3 } from '@modul-connect/shared/components/atoms/text'
import SelectableBarChart from '@modul-connect/shared/components/molecules/barCharts/selectableBarChart'
import View from '@modul-connect/shared/components/atoms/view'
import Card from '@modul-connect/shared/components/atoms/card'
import { CardTitle } from '@modul-connect/shared/components/atoms/text/text'

const TopFiveDisplay = ({
  title,
  data,
  unit,
  tooltipText,
  onSelect,
  onDeselect,
  bgColor
}) => {

  return (
    <Card extend={{
      marginTop: '20px',
      flex: 0,
      backgroundColor: bgColor,
      padding: 20,
      marginBottom: '2%',
      maxWidth: '100%',

    }}>
      
      <View style={{ display: 'flex',flexDirection: 'column',  gap: 10 }}>
        <CardTitle>{title}</CardTitle>
        <Card>
          <SelectableBarChart
            onSelect={onSelect}
            onDeselect={onDeselect}
            data={data}
            unit={unit}
            tooltipText={tooltipText}
          />
        </Card>
      </View>
    </Card>
  )
}

export default TopFiveDisplay
